import type { MetaFunction } from "@remix-run/cloudflare";
import { Link } from "@remix-run/react";
import { SplashScreen } from "~/components/SplashScreen";
import styles from "~/styles/auth.module.css";

export const meta: MetaFunction = () => [
  { title: "Prodigium Account" },
  { name: "description", content: "Prodigium Account — sign in, manage your products and preferences." },
];

export default function AccountIndexPage() {
  return (
    <>
      <SplashScreen name="ACCOUNT" tag="Prodigium Identity Layer" />
      <div className={styles.card} style={{ textAlign: "center" }}>
        <div className={styles.header}>
          <p className={styles.tag}>Prodigium Account</p>
          <h1 className={styles.title}>IDENTITY LAYER</h1>
          <p className={styles.subtitle}>
            Authentication and account management are in development.
            Prodigium Account will give you access to your products, preferences, and purchase history.
          </p>
        </div>

        <div style={{ marginTop: 8, fontSize: 9, letterSpacing: "0.3em", color: "rgba(255,255,255,0.15)", textTransform: "uppercase" }}>
          — Coming Soon —
        </div>

        <div className={styles.actions} style={{ marginTop: 28 }}>
          <Link to="/account/login" className={styles.submitBtn} style={{ textDecoration: "none" }}>
            Sign In
          </Link>
          <Link to="/account/register" className={styles.socialBtn} style={{ textDecoration: "none", height: 44 }}>
            Create Account
          </Link>
        </div>

        <div className={styles.footerLinks} style={{ marginTop: 20 }}>
          <Link to="/" className={styles.backLink} style={{ justifyContent: "center", marginBottom: 0 }}>
            ← Back to OS
          </Link>
        </div>
      </div>
    </>
  );
}
